import { ConfigContext } from 'contexts/config';
import { ModalsContext, ModalType } from 'contexts/modal';
import { LocalStorage } from 'helpers/localStorage';
import { debounce } from 'lodash';
import { useMissionPrize } from 'modules/mission/hooks/useMissionPrize';
import { useContext, useEffect, useRef, useState } from 'react';
import { useCurrentRoute } from 'react-navi';

const missionPromoLS = new LocalStorage<number[], number[]>('mission', []);

export const useMissionModal = () => {
  const { modalComponent, handleModal } = useContext(ModalsContext);
  // other promos reuse the love_quest_* bonuses, only the live mission owns them
  const { isMissionDateValid } = useContext(ConfigContext);

  const ids = useRef<number[]>(missionPromoLS.get() || []);
  const prize = useMissionPrize();
  const [debouncedPrize, setDebouncedPrize] = useState(prize);

  const {
    url: { pathname },
  } = useCurrentRoute();

  useEffect(() => {
    const debouncedSetPrize = debounce(() => {
      setDebouncedPrize(prize);
    }, 5000);

    debouncedSetPrize();

    return () => {
      debouncedSetPrize.cancel();
    };
  }, [prize]);

  useEffect(() => {
    const isGamePage = pathname.startsWith('/game/');

    if (
      isMissionDateValid &&
      !modalComponent &&
      debouncedPrize &&
      !isGamePage
    ) {
      const isPopupShown = ids.current?.includes(debouncedPrize.id);
      if (isPopupShown) return;
      missionPromoLS.replace([...ids.current, debouncedPrize.id]);
      ids.current = [...ids.current, debouncedPrize.id];
      handleModal(ModalType.MissionComplete)();
    }
  }, [
    pathname,
    modalComponent,
    debouncedPrize,
    handleModal,
    isMissionDateValid,
  ]);
};
